<template>
    <vs-card class="shadow-none m-2 card-content">
        <template slot="header">
            <div>{{card.team_name}}</div>
        </template>
        <div class="p-4">
            <vs-row>
                <vs-col vs-w="6">
                    <div class="p-2">{{i('global.Status').toUpperCase()}}</div>
                </vs-col>
                <vs-col vs-w="3">
                    <div class="text-center p-2">{{i('global.Leads').toUpperCase()}}</div>
                </vs-col>
                <vs-col vs-w="3">
                    <div class="text-center p-2">{{i('global.PCT')}}</div>
                </vs-col>
                <vs-divider class="m-0" color="#F8F8F8"/>
            </vs-row>
            <vs-row v-for="(value, key) of exclude(card)" :key="key">
                <vs-col vs-w="6">
                    <div class="p-2">{{key}}</div>
                </vs-col>
                <vs-col vs-w="3">
                    <div :style="`color: ${getColorForCard(key)}`" class="text-center p-2">{{~~value}}</div>
                </vs-col>
                <vs-col vs-w="3">
                    <div 
                        :style="`color: ${getColorForCard(key)}`" 
                        class="text-center p-2"
                    >
                        {{~~value ? ((~~value / ~~card.total) * 100).toFixed(2) : 0}}%
                    </div>
                </vs-col>
                <vs-divider class="m-0" color="#F8F8F8" />
            </vs-row>
        </div>
    </vs-card>
</template>

<script>
import i18n from '../../../i18n/i18n'
import {colorGeoCard} from '@/utils/mixins'

export default {
    props: ['card'],

    mixins: [colorGeoCard],

    methods: {
        exclude(object) {
            const obj = {}
            for (const key in object) {
                if (!['team_name', 'total'].includes(key)) {
                    obj[key] = object[key]
                }
            }
            return obj
        },
        i (val) {
            return i18n.tc(val)
        }
    }
}
</script>

<style lang="scss">
    .card-content {
        .vs-card--content {
            padding: 0;
            margin: 0;
        }
    }
</style>